module.exports = __webpack_public_path__ + "static/media/4.63e7b543.jpg";